import { motion } from "framer-motion";
import { inr } from "../data/products";
import { EASE } from "./Reveal";

export const ProductCard = ({ product, index = 0 }) => (
  <motion.article
    layout
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: 24 }}
    viewport={{ once: true, margin: "-50px" }}
    transition={{ duration: 0.85, delay: (index % 4) * 0.08, ease: EASE }}
    className="group cursor-pointer"
    data-testid={`product-card-${product.handle}`}
  >
    <div className="relative aspect-[4/5] overflow-hidden rounded-lg bg-sand">
      <img
        src={product.image}
        alt={product.name}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
      />
      {product.tag && (
        <span className="absolute left-4 top-4 rounded-full bg-ivory/90 px-3 py-1 text-[10px] uppercase tracking-[0.2em] text-golddark backdrop-blur-sm">
          {product.tag}
        </span>
      )}
      <span className="absolute inset-x-0 bottom-0 h-px origin-left scale-x-0 bg-gold transition-transform duration-500 group-hover:scale-x-100" />
    </div>
    <div className="mt-5">
      <p className="text-[11px] uppercase tracking-[0.25em] text-smoke">{product.category}</p>
      <h3 className="mt-1 font-serif text-xl tracking-tight text-ink">
        <span className="gold-underline pb-0.5">{product.name}</span>
      </h3>
      <p className="mt-2 text-sm text-ink">
        <span className="font-medium">{inr(product.price)}</span>
        <span className="ml-3 text-smoke line-through">{inr(product.compareAt)}</span>
      </p>
    </div>
  </motion.article>
);
